import { useEffect, useMemo, useState } from "react";

import { ApiEndpoints, ApiResponse, getApiClient } from "../../api-http";
import { useLocaleContext } from "../../i18n/locale-context";
import { Event } from "./types";
import { useEventsLocale } from "./use-events-locale";

export function useGetEvents() {
  const { locale } = useLocaleContext();
  const [events, setEvents] = useState<Event[]>([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const eventsLocale = useEventsLocale();

  useEffect(() => {
    setLoading(true);
    const client = getApiClient({
      withCredentials: false,
      headers: {
        "Accept-Language": eventsLocale,
      },
    });

    client
      .get<ApiResponse<Event[]>>(ApiEndpoints.EVENTS)
      .then(({ data: { data: events } }) => {
        setEvents(events ?? []);
        return events;
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [eventsLocale, locale]);

  return useMemo(
    () => ({
      events,
      loading,
      error,
    }),
    [error, events, loading]
  );
}
